<template>
  <header>
    <div class="header_logo">
      <img height="50" src="@/assets/img/logo_inventory_amount.png" alt="Logo" />
      <span style="margin-left: 1rem">Ver. 2026.9.9.1</span>
    </div>
    <div class="language">
      <select v-model="selectedLanguage" class="form-select" aria-label="Default select example">
        <option selected disabled value="Language">🌐　Language</option>
        <option value="ja">日本語</option>
        <option value="en">English</option>
      </select>
    </div>
  </header>
  <div class="lineblock"></div>
  <div class="home">
    <div class="whatis">
      <h4>
        {{ $t("Home.whatIs") }}
        <a href="https://support.zaico.co.jp/hc/ja/articles/5212791543321" target="_blank">
          <img height="20" src="@/assets/img/help.png" alt="help" />
        </a>
      </h4>
      <div class="content">{{ $t("Home.thisIs") }}<br /></div>
    </div>

    <div class="section account">
      <h4>{{ $t("Home.account") }}</h4>
      <div class="content">
        <div>
          <div style="width: 120px; display: inline-block">{{ $t("Home.companyName") }}</div>
          ：<b style="font-size: 20px">{{ companyName }}</b>
        </div>
        <div>
          <div style="width: 120px; display: inline-block">{{ $t("Home.planName") }}</div>
          ：<b style="font-size: 20px">{{ planName }}</b>
        </div>
        <div>
          <div style="width: 120px; display: inline-block">{{ $t("Home.userName") }}</div>
          ：<b style="font-size: 20px">{{ userName }}</b>
        </div>
        <div class="content_note">
          <div>※{{ $t("Home.changeAccount") }} <a href="https://web.zaico.co.jp/" target="_blank">zaicoを開く</a></div>
        </div>
      </div>
    </div>

    <template v-if="!this.planName"> </template>
    <template v-else-if="this.planName && this.canUse()">
      <ul class="nav nav-tabs mt-5" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            id="one-day-tab"
            data-bs-toggle="tab"
            data-bs-target="#one-day-tab-pane"
            type="button"
            role="tab"
            aria-controls="one-day-tab-pane"
            aria-selected="false"
            @click="saveActiveTab('one-day-tab')"
          >
            {{ $t("Home.Amount_of_inventory_on_the_specified_date") }}
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="tow-days-tab"
            data-bs-toggle="tab"
            data-bs-target="#tow-days-tab-pane"
            type="button"
            role="tab"
            aria-controls="tow-days-tab-pane"
            aria-selected="true"
            @click="saveActiveTab('tow-days-tab')"
          >
            {{ $t("Home.Increase_or_decrease_in_the_amount_of_inventory_during_the_period") }}
          </button>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="one-day-tab-pane"
          role="tabpanel"
          aria-labelledby="one-day-tab"
          tabindex="0"
        >
          <OneDay :selectedLanguage="selectedLanguage" :is_advanced_plan="is_advanced_plan" :maxPreviewRowsAggregatedList="maxPreviewRowsAggregatedList" />
        </div>
        <div class="tab-pane fade" id="tow-days-tab-pane" role="tabpanel" aria-labelledby="tow-days-tab" tabindex="1">
          <TowDays :selectedLanguage="selectedLanguage" :is_advanced_plan="is_advanced_plan" :maxPreviewRowsAggregatedList="maxPreviewRowsAggregatedList" />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="alert alert-danger" role="alert">
        <span>
          {{ $t("Home.makeSurePlan") }}
          &nbsp;
          <a href="https://www.zaico.co.jp/smart-zaico/help/contact/" target="_blank">HELP</a>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import OneDay from "./OneDay";
import TowDays from "./TowDays";
// API実行
import axios from "axios";

export default {
  name: "Home",
  components: {
    OneDay,
    TowDays,
  },
  data() {
    return {
      NODE_ENV: process.env.NODE_ENV,
      selectedLanguage: "Language",
      userName: "",
      userId: "",
      companyName: "",
      planName: "",
      errorMsg: "",
      activeTab: "one-day-tab",
      is_advanced_plan: false,
      maxPreviewRowsAggregatedList: 1000,
    };
  },
  watch: {
    selectedLanguage: function (language) {
      console.log("start selectedLanguage");
      this.$i18n.locale = language;
      localStorage.setItem("language", language);
      return language;
    },
  },
  computed: {
    accessToken: function () {
      return this.$store.state.accessToken;
    },
  },
  created() {
    console.log("created");

    const language = localStorage.getItem("language");
    if (language) {
      this.selectedLanguage = language;
    } else {
      this.selectedLanguage = "ja";
    }

    console.log("this.accessToken: " + this.accessToken);
    console.log("this.$route.query.code: " + this.$route.query.code);
    if (this.$route.query.code) {
      this.getAccessToken();
      return;
    }
    if (this.$route.query.accessToken) {
      this.$store.commit("setAccessToken", this.$route.query.accessToken);
      this.$router.push("/");
    }
    if (this.accessToken == "") {
      this.openRedirectURL();
      return;
    }
    this.setUserName();
  },
  methods: {
    saveActiveTab(tabId) {
      localStorage.setItem("activeTab", tabId);
      this.activeTab = tabId;
    },
    loadActiveTab() {
      const savedTab = localStorage.getItem("activeTab");
      if (savedTab) {
        this.activeTab = savedTab;
        const tabElement = document.getElementById(savedTab);
        if (tabElement) {
          tabElement.click();
        }
      }
    },
    /**
     * アクセストークンを取得するAPIを実行する。
     * サーバ側でaccessTokenパラメータが付与された状態で、当画面にリダイレクトする。
     * @type {function}
     */
    async getAccessToken() {
      console.log("/auth/callback　開始");
      console.log(this.$route.fullPath);
      axios.get("/auth/callback", {
        params: {
          code: this.$route.query.code,
        },
      });
    },
    /**
     * userNameをセットする
     */
    async setUserName() {
      let profile = await this.fetchProfile();
      this.userName = profile.name;
      this.userId = profile.id;
      this.companyName = profile.company_name;
      this.planName = profile.plan_name;
      this.$gtag.event("login", { user_id: this.userId });
    },
    /**
     * APIからプロフィールを取得する。
     * @type {function}
     * @returns {string} - userName
     */
    async fetchProfile() {
      const res = await axios.get("/profile/me.json", {
        params: {
          accessToken: this.accessToken,
        },
      });
      return res.data.data;
    },

    /**
     * OAuth認証画面を開く。
     * @type {function}
     */
    async openRedirectURL() {
      this.$gtag.event("before login");
      const res = await axios.get("/auth", {});
      console.log({ res });
      window.open(res.data, "_self");
    },

    /**
     * 本来ならprofile/using_subscription.jsonからプランコードを取得する方が良いのだが、
     * なぜかエラーになって取得できないので暫定的にプラン名で判定する
     */
    canUse() {
      setTimeout(() => {
        this.loadActiveTab();
      }, 100);
      // 在庫金額アプリを利用できないプラン名の配列を定義
      // この配列に含まれるプランを利用中の場合、在庫金額アプリは利用できない
      const disallowedPlans = ["無料プラン", "Free plan", "ミニマムプラン", "Minimum plan", "エントリープラン", "Entry plan"];
      const isDisallowedPlan = disallowedPlans.some((plan) => this.planName.includes(plan));
      // 上位プラン名の配列を定義
      // この配列に含まれるプランを利用中の場合、全ての機能が利用可能（移動平均法での計算が可能、取得可能な行数が1000件になるetc）
      const advancedPlans = ["フルプラン", "Full plan", "proプラン", "Pro plan"];
      this.is_advanced_plan = advancedPlans.some((plan) => this.planName.includes(plan));
      if (!this.is_advanced_plan) {
        this.maxPreviewRowsAggregatedList = 5;
      }
      return !isDisallowedPlan;
    },
  },
};
</script>

<style>
.home {
  margin: 1.5rem 1.5rem 1.5rem 1.5rem;
}

.content {
  margin-left: 1rem;
}

.btn-info {
  color: #fff;
}

.btn-info:hover {
  color: #fff;
}

.language {
  float: right;
}

.green {
  background: green !important;
}

.red {
  background: rgb(253, 203, 203);
}

thead {
  position: sticky;
  top: 0;
}

th {
  white-space: nowrap;
}

td {
  white-space: nowrap;
}
</style>
